import styled from "styled-components";

export const Main = styled.div`
   width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
   .status, .log {
      background-color: rgb(245, 245, 245);
      border: 1px solid rgb(220, 220, 220);
      border-radius: 10px;
      padding: 7.5px 15px;
      font-size: 15px;
   }
   .status {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 35px;

      > div {
         display: flex;
         justify-content: center;
         align-items: center;
         width: 150px;
         margin-bottom: 3px;

         &:not(:last-of-type) {
            margin-bottom: 7.5px;
         }
         span:first-of-type {
            width: 10px;
            height: 10px;
            background-color: #339966;
            margin-right: 7.5px;
            border-radius: 2px;
            box-shadow: 0 0 3px #339966;
         }
         span:last-of-type {
            opacity: 0.85;
         }
      }
      .empty {
         opacity: 0.8;
         text-align: center;
      }
   }
   .log {
      margin-top: 7.5px;
      
      li {
         text-align: center;
         
         &:not(:last-of-type) {
            border-bottom: 1px solid rgb(220, 220, 220);
            padding-bottom: 5px;
         }
         &:not(:first-of-type) {
            margin-top: 5px;
         }
      }
   }
`;